import {
  REQUEST_STRIPE_CARD_TOKEN_SENT,
  REQUEST_STRIPE_CARD_TOKEN_SUCCEEDED,
  REQUEST_STRIPE_CARD_TOKEN_FAILED,
  FETCH_STRIPE_CARD_SENT,
  FETCH_STRIPE_CARD_SUCCEEDED,
  FETCH_STRIPE_CARD_FAILED,
  ADD_STRIPE_CARD_SENT,
  ADD_STRIPE_CARD_SUCCEEDED,
  ADD_STRIPE_CARD_FAILED,
} from '../../actions/stripeMethod';

import {
  SETUP_PAYPAL_AGREEMENT_SENT,
  SETUP_PAYPAL_AGREEMENT_SUCCEEDED,
  SETUP_PAYPAL_AGREEMENT_FAILED,
} from '../../actions/payment';

const initialState = {
  card: null,
  loading: false,
  loaded: false,
  requestingToken: false,
  saving: false,
  cardToken: null,
  errorCode: null,
  errorMessage: null,
  paypalToken: null,
  waitingPaypalToken: false,
};

export default function paymentMethodReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case REQUEST_STRIPE_CARD_TOKEN_SENT:
      return {
        ...state,
        saving: true,
      };
    case SETUP_PAYPAL_AGREEMENT_SENT:
      return {
        ...state,
        waitingPaypalToken: true,
      };
    case REQUEST_STRIPE_CARD_TOKEN_FAILED:
      return {
        ...state,
        saving: false,
        errorCode: payload.error.code,
        errorMessage: null,
      };
    case SETUP_PAYPAL_AGREEMENT_FAILED:
      return {
        ...state,
        waitingPaypalToken: false,
      };
    case REQUEST_STRIPE_CARD_TOKEN_SUCCEEDED:
      return {
        ...state,
        saving: false,
        errorCode: null,
        cardToken: payload.id,
        errorMessage: null,
        loaded: false,
      };
    case SETUP_PAYPAL_AGREEMENT_SUCCEEDED:
      return {
        ...state,
        waitingPaypalToken: false,
        paypalToken: payload.token,
      };
    case FETCH_STRIPE_CARD_SENT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_STRIPE_CARD_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_STRIPE_CARD_SUCCEEDED:
      return {
        ...state,
        loading: false,
        loaded: true,
        card: payload.card,
      };
    case ADD_STRIPE_CARD_SENT:
      return {
        ...state,
        saving: true,
      };
    case ADD_STRIPE_CARD_FAILED:
      return {
        ...state,
        saving: false,
        cardToken: null,
        errorCode: null,
        errorMessage: payload.message,
        loaded: false,
      };
    case ADD_STRIPE_CARD_SUCCEEDED:
      return {
        ...state,
        saving: false,
        card: payload.card,
        cardToken: null,
        errorCode: null,
        errorMessage: null,
        loaded: true,
      };

    default:
      return state;
  }
}
